import { features } from '@/mocks/reviews';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            核心功能介绍
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大核心模块，为您的数据管理和业务决策提供全方位支持
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 bg-background-50 border border-background-200 rounded-lg hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}